<template>
  <div class="workOrderDetail">
    <div class="top">
      <div class="projectName">{{ detail.orderVo.description }}</div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div style="display: flex; flex-direction: row">
          <div class="orderApply">
            工单提出人：{{ detail.orderVo.applyName }}
          </div>
          <div class="orderApply">
            工单时间：{{ detail.orderVo.createTime }}
          </div>
          <div class="orderApply">工单编号：{{ detail.orderVo.id }}</div>
        </div>
        <el-button type="primary" size="small" @click="exportWorkOrderDetail"
          >导出工单详情</el-button
        >
      </div>
      <div style="display: flex; flex-direction: row">
        <div class="orderApply">{{ detail.orderVo.projectName }}</div>
        <div class="orderApply"></div>
        <div class="orderApply" style="display: flex; flex-direction: row">
          <img
            style="margin-right: 10px"
            src="@/assets/teamGroup/manager_icon.png"
            alt=""
          />
          {{ detail.orderVo.managerName }}
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          height: 100px;
          padding-top: 20px;
        "
      >
        <div
          style="
            width: 50px;
            height: 100%;
            font-size: 16px;
            height: 26px;
            line-height: 26px;
          "
        >
          图片:
        </div>
        <div
          v-for="(image, index) in fileList"
          :key="index"
          style="height: 80px; width: 80px; margin-left: 10px"
        >
          <img
            :src="image"
            style="width: 100%; height: 100%"
            class="thumbnail"
            @click="openViewer(index)"
          />
        </div>
      </div>
    </div>
    <div>
      <div style="margin-top: 20px">
        <el-tabs type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(task, index) in detail.busTask"
            :key="'tab' + index"
            :label="task.groupName + '-' + task.groupManageName"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div
        style="display: flex; flex-direction: row; height: calc(100% - 60px)"
      >
        <div class="left">
          <div
            v-for="(item, index) in workInfoList"
            :key="index"
            class="time"
            @click="chooseDate(index)"
            :class="{ timeChoose: selectWorkItemId == item.id }"
          >
            {{ item.workDate }}
          </div>
        </div>
        <div class="middle">
          <div class="address">
            <div style="margin-right: 20px"># {{ workName }}</div>
            <!--            <img-->
            <!--              style="width: 20px; height: 20px"-->
            <!--              src="@/assets/teamGroup/location_icon.png"-->
            <!--              alt=""-->
            <!--            />-->
          </div>
          <div>
            <div class="title">现场情况描述</div>
            <div>{{ workInfo.description }}</div>
            <div style="height: auto; padding: 20px 0">
              <!-- <img
                style="width: 200px; height: auto; margin-right: 10px"
                v-for="(item, index) in workInfo.photoList"
                :src="item"
                alt=""
                @click="previewImage(item)"
              /> -->
              <el-image
                style="width: 160px; height: 120px; margin-right: 10px"
                v-for="(item, index) in workInfo.photoList"
                :key="index"
                :src="item"
                :preview-src-list="[item]"
              ></el-image>
            </div>
          </div>
          <div>
            <div class="title">现场视频</div>
            <div style="height: auto; padding: 20px 0">
              <div v-for="(item, index) in workInfo.jlyList" :key="index">
                <video
                  style="width: 200px; height: auto; margin-right: 10px"
                  v-if="item.length > 0"
                  :src="item"
                  alt=""
                  controls="controls"
                ></video>
              </div>
            </div>
          </div>
          <div>
            <div class="title">关键节点</div>
            <div
              style="
                display: inline-block;
                flex-direction: row;
                position: relative;
                width: auto;
              "
            >
              <div
                style="
                  position: absolute;
                  width: 100%;
                  height: 1px;
                  border-top: 1px dashed #ccc;
                  left: 0;
                  top: 65px;
                  z-index: 1;
                "
              ></div>
              <div
                style="display: inline-block; position: relative; z-index: 999"
              >
                <div class="checkItem" v-if="workInfo.checkInTime">
                  <div class="type">工人签到</div>
                  <div
                    style="
                      width: 10px;
                      height: 10px;
                      border: 1px solid #ccc;
                      border-radius: 50%;
                      background-color: white;
                    "
                  ></div>
                  <div>{{ workInfo.checkInTime }}</div>
                  <img :src="workInfo.checkInUrl" alt="" />
                </div>
              </div>
              <div
                style="display: inline-block; position: relative; z-index: 999"
              >
                <div class="checkItem" v-if="workInfo.checkOutTime">
                  <div class="type">工人签退</div>
                  <div
                    style="
                      width: 10px;
                      height: 10px;
                      border: 1px solid #ccc;
                      border-radius: 50%;
                      background-color: white;
                    "
                  ></div>
                  <div>{{ workInfo.checkOutTime }}</div>
                  <img :src="workInfo.checkOutUrl" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="rightTop">
            <div class="car">
              <div
                class="carItem"
                v-for="(item, index) in detail.taskCarList"
                :key="index"
              >
                <div class="carIcon">
                  <img src="@/assets/teamGroup/car_icon.png" alt="" />
                </div>
                <div class="carName">{{ item.carNum }}</div>
                <div class="carInfo">
                  <div class="tips warining" v-if="item.carMark === 0">固</div>
                  <div class="tips primary" v-else-if="item.carMark === 1">
                    流
                  </div>
                  <div class="tips success" v-if="item.insuranceMark === 1">
                    保
                  </div>
                </div>
                <div class="carRoad" @click="goToCarPath(item)">[轨迹]</div>
              </div>
            </div>
            <!-- <div class="manager">
              <div class="managerIcon">
                <img
                  style="width: 30px; height: 30px"
                  src="@/assets/teamGroup/manager_icon.png"
                  alt=""
                />
              </div>
              <div class="managerName">陈春林</div>
            </div> -->
          </div>
          <div>
            <div
              style="
                font-size: 16px;
                font-weight: 600;
                height: 20px;
                line-height: 20px;
                margin-top: 20px;
              "
            >
              工作量计算
            </div>
            <div
              v-for="(item, index) in workInfo.itemQuantityList"
              :key="'quantity' + index"
              style="border-bottom: 1px solid #ccc"
            >
              <div class="workItem">
                <div class="workName">
                  {{ item.workItemName }}
                </div>
                <div class="workQuantity">
                  {{ item.quantity }}({{ item.workItemUnitName }})
                </div>
              </div>
              <div style="padding-bottom: 5px">备注:{{ item.remark }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="dialogVisible"
      class="dialog-overlay"
      @click="dialogVisible = false"
    >
      <img
        :src="fileList[currentIndex]"
        alt="Selected Image"
        class="image-slide"
      />
    </div>
    <div></div>
  </div>
</template>

<script>
import WorkOrderApi from "@/api/workOrder";
export default {
  name: "WorkOrderDetail",
  data() {
    return {
      dialogVisible: false,
      currentIndex: 0,
      fileList: [],
      detail: {
        orderVo: {},
      },
      workInfo: {},
      workInfoList: [],
      workName: "",
      selectDate: "",
      selectWorkItemId: "",
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    openViewer(index) {
      this.currentIndex = index;
      this.dialogVisible = true;
    },
    prevImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.fileList.length) % this.fileList.length;
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.fileList.length;
    },
    previewImage(url) {
      window.open(url);
    },
    handleClick(tab) {
      // console.log(tab.index);
      let groupIndex = parseInt(tab.index);
      this.workInfoList = this.detail.busTask[groupIndex].busTaskItems;
      this.workName = this.detail.busTask[groupIndex].workName;
      if (this.workInfoList && this.workInfoList.length > 0) {
        this.selectDate = this.workInfoList[0].workDate;
        this.workInfo = this.workInfoList[0];
        this.workInfo.photoList = this.workInfo.photoUrl.split(",");
        this.workInfo.jlyList = this.workInfo.cameraUrl.split(",");
      }
    },
    chooseDate(index) {
      this.workInfo = this.workInfoList[index];
      this.selectDate = this.workInfo.workDate;
      this.selectWorkItemId = this.workInfo.id;
      // console.log("left");
    },
    goToCarPath(car) {
      this.$router.push(
        "/carLocation?no=" + car.carNum + "&date=" + this.selectDate + "&type=1"
      );
    },
    getDetail() {
      WorkOrderApi.workOrderDetail({
        id: this.$route.query.id,
      }).then((res) => {
        this.detail = res.data.data;
        console.log("工单详情:", this.detail);
        console.log("工单信息(orderVo):", this.detail.orderVo);
        console.log("图片URL(photoUrl):", this.detail.orderVo.photoUrl);
        console.log("任务列表(busTask):", this.detail.busTask);
        if (this.detail.busTask && this.detail.busTask.length > 0) {
          console.log(
            "第一个任务的作业项:",
            this.detail.busTask[0].busTaskItems
          );
        }
        // 调用JSON下载函数，下载detail数据
        // this.downloadJsonFile(
        //   this.detail,
        //   `工单详情_${this.$route.query.id}.json`,
        // );
        this.fileList = this.detail.orderVo.photoUrl.split(",");

        if (this.detail.busTask && this.detail.busTask.length > 0) {
          let groupIndex = 0;
          this.workInfoList = this.detail.busTask[groupIndex].busTaskItems;
          this.workName = this.detail.busTask[groupIndex].workName;
          if (this.workInfoList && this.workInfoList.length > 0) {
            this.selectDate = this.workInfoList[0].workDate;
            this.workInfo = this.workInfoList[0];

            //切全部
            this.workInfoList.forEach((value, index) => {
              // console.log(index + ">" + value);
              value.photoList = value.photoUrl.split(",");
              value.jlyList = value.cameraUrl.split(",");
            });
          }
        }
      });
    },
    // 封装JSON文件下载函数
    // downloadJsonFile(data, fileName) {
    //   try {
    //     // 1. 将数据转换为格式化的JSON字符串（缩进2个空格，便于阅读）
    //     const jsonStr = JSON.stringify(data, null, 2);
    //     // 2. 创建Blob对象，指定MIME类型为json
    //     const blob = new Blob([jsonStr], {
    //       type: "application/json;charset=utf-8",
    //     });
    //     // 3. 创建临时的a标签
    //     const a = document.createElement("a");
    //     // 4. 创建下载链接
    //     const url = URL.createObjectURL(blob);
    //     a.href = url;
    //     // 5. 设置下载文件名
    //     a.download = fileName;
    //     // 6. 触发点击下载
    //     a.click();
    //     // 7. 释放URL对象，避免内存泄漏
    //     URL.revokeObjectURL(url);

    //     console.log(`JSON文件 ${fileName} 下载成功`);
    //     // 可选：添加成功提示
    //     // this.$message.success('工单详情已下载为JSON文件');
    //   } catch (error) {
    //     console.error("JSON文件下载失败:", error);
    //     // 可选：添加失败提示
    //     // this.$message.error('JSON文件下载失败，请重试');
    //   }
    // },
    // 导出工单详情为Word
    async exportWorkOrderDetail() {
      try {
        this.$message.loading("正在生成工单文档...");

        // 动态导入所需库
        const Docxtemplater = await import("docxtemplater");
        const PizZip = await import("pizzip");
        const ImageModule = await import("docxtemplater-image-module-free");
        const { saveAs } = await import("file-saver");

        // 加载模板文件
        const response = await fetch("/templates/workOrderTemplate.docx");
        if (!response.ok) {
          // 如果模板不存在，使用简单的Excel导出作为备选
          this.exportAsExcel();
          return;
        }
        const templateContent = await response.arrayBuffer();

        // 初始化图片模块
        const imageModule = new ImageModule.default({
          centered: false,
          getImage: (tagValue) => {
            return new Promise((resolve, reject) => {
              if (!tagValue || tagValue === "undefined") {
                reject(new Error("Invalid image URL"));
                return;
              }
              const xhr = new XMLHttpRequest();
              xhr.open("GET", tagValue, true);
              xhr.responseType = "arraybuffer";
              xhr.onload = function () {
                if (xhr.status === 200) {
                  resolve(xhr.response);
                } else {
                  reject(new Error("Failed to load image"));
                }
              };
              xhr.onerror = () => reject(new Error("Image load error"));
              xhr.send();
            });
          },
          getSize: () => [150, 150], // 图片尺寸 [宽, 高]
        });

        // 创建 ZIP 实例
        const zip = new PizZip.default(templateContent);

        // 创建 docxtemplater 实例
        const doc = new Docxtemplater.default(zip, {
          modules: [imageModule],
          paragraphLoop: true,
          linebreaks: true,
        });

        // 准备数据
        const orderVo = this.detail.orderVo || {};
        const busTask = this.detail.busTask || [];

        // 组装作业数据
        const taskList = busTask.map((task) => {
          const items = task.busTaskItems || [];
          return {
            workName: task.workName || "",
            groupName: task.groupName || "",
            groupManageName: task.groupManageName || "",
            items: items.map((item) => ({
              workDate: item.workDate || "",
              description: item.description || "",
              photoList: item.photoUrl ? item.photoUrl.split(",") : [],
            })),
          };
        });

        // 设置模板数据
        doc.setData({
          orderId: orderVo.id || "",
          description: orderVo.description || "",
          applyName: orderVo.applyName || "",
          createTime: orderVo.createTime || "",
          projectName: orderVo.projectName || "",
          managerName: orderVo.managerName || "",
          photoList: this.fileList || [],
          taskList: taskList,
        });

        // 渲染文档
        doc.render();

        // 生成输出
        const output = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        // 保存文件
        saveAs(output, `工单详情_${orderVo.id || "export"}.docx`);
        this.$message.success("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("Word导出失败，尝试使用Excel导出");
        // 失败时使用Excel导出作为备选
        this.exportAsExcel();
      }
    },
    // 备选：导出为Excel
    exportAsExcel() {
      const orderVo = this.detail.orderVo || {};
      const busTask = this.detail.busTask || [];

      // 组装数据
      const exportData = [];

      // 工单基本信息
      exportData.push({
        type: "工单信息",
        label: "工单编号",
        value: orderVo.id || "",
      });
      exportData.push({
        type: "工单信息",
        label: "工单描述",
        value: orderVo.description || "",
      });
      exportData.push({
        type: "工单信息",
        label: "提出人",
        value: orderVo.applyName || "",
      });
      exportData.push({
        type: "工单信息",
        label: "提出时间",
        value: orderVo.createTime || "",
      });
      exportData.push({
        type: "工单信息",
        label: "项目名称",
        value: orderVo.projectName || "",
      });
      exportData.push({
        type: "工单信息",
        label: "项目经理",
        value: orderVo.managerName || "",
      });

      // 任务信息
      busTask.forEach((task, taskIndex) => {
        exportData.push({
          type: `任务${taskIndex + 1}`,
          label: "任务名称",
          value: task.workName || "",
        });
        exportData.push({
          type: `任务${taskIndex + 1}`,
          label: "班组",
          value: `${task.groupName || ""} - ${task.groupManageName || ""}`,
        });

        const items = task.busTaskItems || [];
        items.forEach((item, itemIndex) => {
          exportData.push({
            type: `任务${taskIndex + 1}`,
            label: `作业${itemIndex + 1}日期`,
            value: item.workDate || "",
          });
          exportData.push({
            type: `任务${taskIndex + 1}`,
            label: `作业${itemIndex + 1}描述`,
            value: item.description || "",
          });
        });
      });

      // 导入导出工具
      import("@/utils/xlsx.js").then(({ xlsx }) => {
        xlsx(
          exportData,
          { type: "类型", label: "项目", value: "内容" },
          `工单详情_${orderVo.id || "export"}.xlsx`
        );
        this.$message.success("Excel导出成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.image-gallery {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.thumbnail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  object-fit: cover;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-slide {
  max-width: 100%;
  max-height: 80vh;
}

.controls {
  margin-top: 10px;
}

.controls button {
  margin: 0 10px;
  padding: 8px 16px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
  color: #333;
}
.workOrderDetail {
  padding: 20px;
  min-width: 1100px;
  overflow: hidden;
  overflow-y: auto;

  .top {
    border-bottom: 1px solid #ccc;
    padding-bottom: 20px;

    .projectName {
      font-size: 26px;
      font-weight: 600;
      height: 30px;
      line-height: 30px;
    }

    .orderApply {
      flex: 1;
      margin-top: 10px;
      font-size: 16px;
      height: 26px;
      line-height: 26px;
    }
  }

  .left {
    width: 100px;
    border-right: 1px solid #ccc;
    flex-shrink: 0;

    .time {
      height: 50px;
      line-height: 50px;
      text-align: right;
      padding-right: 10px;
      color: black;
    }

    .time:hover {
      background-color: #409eff;
      color: white;
    }

    .timeChoose {
      background-color: #409eff;
      color: white;
    }
  }

  .middle {
    padding: 0 20px;
    flex: 1;

    .address {
      float: right;
      display: flex;
      flex-direction: row;
    }

    .title {
      font-weight: 600;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
    }
  }

  .right {
    width: 500px;
    border-left: 1px solid #ccc;
    padding-left: 10px;
    flex-shrink: 0;

    .rightTop {
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #ccc;
      padding-bottom: 20px;
      align-items: center;

      .car {
        border-right: 1px solid #ccc;
        flex: 1;

        .carItem {
          display: flex;
          flex-direction: row;
          margin-right: 20px;
          padding: 10px 0;
          align-items: center;

          .carIcon {
            width: 30px;
            height: 30px;

            img {
              width: 30px;
              height: 30px;
            }
          }

          .carName {
            height: 20px;
            line-height: 20px;
            margin-left: 10px;
          }

          .carInfo {
            width: auto;
            height: 20px;
            margin-left: 10px;

            .tips {
              height: 20px;
              width: 20px;
              line-height: 20px;
              text-align: center;
              color: white;
              background-color: #e6a23c;
              border-radius: 2px;
              display: inline-block;
              margin-right: 2px;
            }

            .success {
              background-color: #67c23a;
            }

            .waring {
              background-color: #e6a23c;
            }

            .danger {
              background-color: #f56c6c;
            }

            .primary {
              background-color: #409eff;
            }
          }

          .carRoad {
            height: 20px;
            line-height: 20px;
            margin-left: 10px;
            color: red;
            cursor: pointer;
          }
        }
      }

      .manager {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 120px;

        .managerIcon {
          width: 30px;
          height: 30px;
          margin-left: 10px;
        }

        .managerName {
          margin-left: 10px;
        }
      }
    }

    .workItem {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 40px;
      line-height: 40px;

      .workName {
        flex: 5;
      }

      .workQuantity {
        flex: 1;
        text-align: right;
      }
    }
  }

  .checkItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin: 20px;
    padding: 10px 20px;
    width: 180px;

    div {
      height: 30px;
      line-height: 30px;
    }

    img {
      width: 100px;
      height: 100px;
    }

    .type {
      font-weight: 600;
    }
  }
}
</style>
